import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {
    ActionResponse,
    DocumentCapabilitySlotsRequest,
    LoanRequest,
    LoanRequestFormActionResponse,
    LoanRequestItem,
    RedirectionResponse
} from 'typings/portaro.be.types';
import type {KpUniversalFormSettings} from '../value-editors/kp-universal-form/types';
import type {AnyObject} from 'typings/portaro.fe.types';

/**
 * @ngdoc service
 * @name loanRequestDataService
 * @module portaro.data-services
 *
 * @requires Restangular
 *
 * @description
 */
export default class LoanRequestDataService {
    public static serviceName = 'loanRequestDataService';

    private static readonly REQUESTS_ROUTE = '/loan-items/request';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async requestLoanForm(items: LoanRequestItem[]): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        try {
            return await this.Restangular
                .all(LoanRequestDataService.REQUESTS_ROUTE)
                .post(transferify(items));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async requestLoan(endpointPath: string, loanRequest: LoanRequest): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .all(LoanRequestDataService.REQUESTS_ROUTE)
                .all(endpointPath)
                .post(transferify(loanRequest));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getDocumentCapabilityForm(capability: string, params: DocumentCapabilitySlotsRequest): Promise<KpUniversalFormSettings<AnyObject>> {
        try {
            return await this.Restangular
                .all(LoanRequestDataService.REQUESTS_ROUTE)
                .all(capability)
                .all('form')
                .post(params);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}
